export const appState = {
    state: {
        /**
         * Objet contenant les paramètres d'affichage de la popin à afficher
         */
        popinParams: {},

        /**
         * Booléean indiquant si les champs obligatoires concernant l'entreprise ont été complétés
         */
        compagnyCompleted: false,

        /**
         * Paramètres d'affichage en colonne de l'écran d'évaluation d'un thème (observations des sous-thèmes et éléments d'objectivation)
         */
        themesColumns: {
            // Nb de colonnes maximum affichables simultanément
            nbMaxColumns: 4,
            
            // Nb de colonnes à afficher simultanément
            nbDisplayedColumns: 4,

            // Index de la première colonne actuellement affichée (0 = première colonne)
            firstDisplayedColumnIndex: 0
        },

        /**
         * Paramètre de notification permettant le déclanchement de la fonction de validation du formulaire d'entreprise
         */
        tryValidateCompagny: false,
         /**
         * Paramètre indiquant sur quelle view rediriger l'utilisateur après avoir exécuté saveCompagnyForm
         */
        nextViewAfterCompagny: null,

        /**
         * URLs provenant du serveur pour récupérer les données de base et pour demander le rapport PDF
         */
        urls: {
            URL_JSONdata: null,
            URL_GetPDF: null
        },
        /**
         * variable provenant du serveur pour définir si on est en DEV ou non afin d'afficher ou non les messages dans la console
         */
        env: null,

        /**
         * Texte à afficher dans la PopinError
         */
        error: {
            text: null,
            title: null
        },

        /**
         * Version de l'application
         */
        version : null

    },
    mutations: {
        /**
         * Mute à true le flag indiquant que les champs obligatoires concernant l'entreprise ont été complétés.
         * @param {Object} state - L'état à muter
         */
        VALIDATE_COMPAGNY_COMPLETED(state) {
            state.compagnyCompleted = true;
        },

        /**
         * Mute le nombre de colonnes à afficher simultanément.
         * @param {Object} state - L'état à muter
         * @param {number} nb - Nombre de colonnes maximum afficheables simultanément
         */
        SET_NB_MAX_COLUMNS(state, nb) {
            state.themesColumns.nbMaxColumns = nb;
        },

        /**
         * Mute le nombre de colonnes à afficher simultanément.
         * @param {Object} state - L'état à muter
         * @param {number} nb - Nombre de colonnes à afficher simultanément
         */
        SET_NB_DISPLAYED_COLUMNS(state, nb) {
            state.themesColumns.nbDisplayedColumns = nb;
        },

        /**
         * Mute l'index de la 1ère colonne à afficher.
         * @param {Object} state - L'état à muter
         * @param {number} index - Undex de la 1ère colonne à afficher
         */
        SET_FIRST_DISPLAYED_COLUMN_INDEX(state, index) {
            state.themesColumns.firstDisplayedColumnIndex = index;
        },

        /**
         * Mute les paramètres d'affichage de la (prochaine) popin à afficher.
         * @param {Object} state - L'état à muter
         * @param {Object} value - Les paramètres d'affichage de la popin
         */
        SET_POPIN(state, value) {
            state.popinParams = value;
        },

        /**
         * Mute de paramètre permettant le déclanchement de la fonction de validation du formulaire d'entreprise.
         * @param {Object} state - L'état à muter
         * @param {Object} value - La nouvelle valeur à affecter à la variable
         */
        SET_TRY_VALIDATE_COMPAGNY(state, value) {
            state.tryValidateCompagny = value
        }, 

        /**
         * Indique la vue à afficher après avoir quitté la vue formulaire d'entreprise (selon sur quel bouton a cliqué l'utilisateur)
         * @param {Object} state - L'état à muter
         * @param {String} value - nom de la vue à afficher - themesList ou synthesis
         */
        SET_NEXT_VIEW_AFTER_COMPAGNY(state, value) {
            state.nextViewAfterCompagny = value;
        },

        /**
         * Instancie les valeurs des URL du serveur
         * @param {Object} state - L'état à muter
         * @param {String} value - objet contenant les URL nécessaires
         */
        SET_CONFIG(state, value) {
            state.urls = value.urls
            state.env = value.env
            state.version = value.version
        },
        
        /**
         * Instancie la valeur du texte de l'erreur à afficher
         * @param {Object} state - L'état à muter
         * @param {String} value - texte de l'erreur
         */
        SET_ERROR(state, value) {
            state.error = value
        }
    },
    actions: {
        /** 
         * Modifie le nombre de colonnes à afficher simultanément dans la page d'évaluation d'un thème.
         * 
         * @param {Object} context - le contexte à mettre à jour
         * @param {number} nb - nombre de colonnes à afficher
         */
        setNbDisplayedColumns(context, size) {
            // On décale d'abord le tableau à gauche si l'augmentation du nombre de colonnes affichées le nécessite
            var firstDisplayedColumnIndex = context.state.themesColumns.firstDisplayedColumnIndex;
            if (firstDisplayedColumnIndex + size > 4) {
                context.commit('SET_FIRST_DISPLAYED_COLUMN_INDEX', 4 - size);
            }

            context.commit('SET_NB_DISPLAYED_COLUMNS', size);
        },

        /** 
         * Fait glisser (= décale) d'un cran vers la gauche ou la droite l'affichage des colonnes dans la page d'évaluation d'un thème.
         * 
         * @param {Object} context - le contexte à mettre à jour
         * @param {string} direction - Direction de glissement ("right" ou "left")
         */
        swipeDisplayedColumns(context, direction) {                        
            var firstDisplayedColumnIndex = context.state.themesColumns.firstDisplayedColumnIndex;
            var nbDisplayedColumns = context.state.themesColumns.nbDisplayedColumns;

            var nbLevels = 4
            
            if (direction === "right" && (firstDisplayedColumnIndex+nbDisplayedColumns)<nbLevels) {          
                firstDisplayedColumnIndex++;
            }
            else if (direction === "left" && (firstDisplayedColumnIndex)>0) {
                firstDisplayedColumnIndex--;
            }
            else {
                return;
            }
            context.commit('SET_FIRST_DISPLAYED_COLUMN_INDEX', firstDisplayedColumnIndex);
        }
    }

}
